module.exports = __webpack_public_path__ + "static/media/forgotpass.24021047.svg";